<script>
	import Helper from '../../Models/Helper';
	import Gallery from '../../States/Gallery';
	import Product from '../../States/Product';

	let initialized = false;
	let loading = true;
	let success = false;

	async function post(url, data) {
		const method = 'POST';
		const headers = {'Content-Type': 'application/json'};
		const body = JSON.stringify(data);
		const response = await fetch(url, {method, headers, body});
		return response.json();
	}

	function configuration() {
		const data = {
			id: $Product.api.id,
			render: $Gallery.list[0].large,
			properties: {},
			upgrades: [],
			state: $Product.api
		};

		for (let part of $Product.api.parts)
			for (let property of part.properties)
				for (let option of property.options)
					if (option.active)
						data.properties[property.code] = option.code;

		for (let upgrade of $Product.api.upgrades)
			if (upgrade.active)
				data.upgrades.push(upgrade.id);

		return data;
	}

	async function erpState(data) {
		const id = $Product.erp;
		const url = Helper.endpoint(`states/${id}`);
		const response = await post(url, data);
		return response.id;
	}

	async function erpProduct(data) {
		const url = Helper.endpoint('products/create');
		const response = await post(url, data);
		return response.shopify_id;
	}

	async function shopify(id) {
		const url = '/cart/add.js';
		const data = {items: [{id, quantity: 1}]};
		const response = await post(url, data);
		return !!response.items[0].id;
	}

	async function process() {
		let success = false;
		const config = configuration();
		if (!$Product.erp) {
			success = Helper.dev();
			if (!success) {
				const id = await erpProduct(config);
				success = await shopify(id);
			}
		}

		else success = await erpState(config);
		return success;
	}

	Product.subscribe(async product => {
		if (product.basket && !initialized) {
			initialized = true;
			try { success = await process(); }
			catch (error) {
				success = false;
				console.error(error);
			}

			loading = false;
		}
	});
</script>

<style>
	div.phd-basket {
		position: absolute;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		top: 0; right: 0; bottom: 0; left: 0;
		padding: 8%;
		will-change: padding;
		background: var(--phd-background-secondary);
	}

	div.phd-basket-title {
		font-size: 3.5em;
		line-height: 1.25em;
	}

	div.phd-basket-title svg {
		width: 1em;
	}

	div.phd-basket-title span {
		font-style: italic;
		color: var(--phd-secondary);
	}

	.phd-basket-panel {
		font-size: 1.5em;
		display: inline-block;
		background: var(--phd-background-primary);
		padding: 1.25em;
		margin-right: 1em;
		border-radius: .75em;
		margin-bottom: .5em;
		margin-top: .5em;
	}

	.phd-basket-panel-label {
		display: inline-block;
		vertical-align: middle;
	}

	.phd-basket-panel > span {
		display: block;
		font-style: italic;
		color: var(--phd-secondary);
	}

	.phd-basket-panel > svg {
		vertical-align: middle;
		margin-right: .75em;
		width: 1.25em;
		color: var(--phd-quaternary);
	}

	div.phd-basket-next .phd-basket-panel {
		font-size: 2em;
	}

	div.phd-basket-next .phd-basket-panel span {
		margin-bottom: .25em;
	}

	div.phd-basket-next div.phd-knob {
		margin-top: 2em;
		width: 2em;
		height: 2em;
		color: var(--phd-quaternary);
		border-color: var(--phd-quaternary);
	}

	div.phd-knob.phd-knob-product svg {
		width: 50%;
		padding-top: 20%;
		padding-left: 3%;
	}

	div.phd-knob.phd-knob-basket svg {
		width: 50%;
		padding-top: 22%;
	}

	div.phd-basket-next-mobile {
		display: none;
	}

	@media (max-width: 1024px) and (orientation: portrait) {
		div.phd-basket {
			display: block;
			padding: 1.5em 2em 1em 2em;
		}

		div.phd-basket-title {
			font-size: 2.5em;
			margin-top: .5em;
			margin-bottom: 1.25em;
		}

		.phd-basket-panel {
			display: block;
			margin: 0;
		}

		div.phd-basket-usp > .phd-basket-panel:first-child {
			padding-bottom: .5em;
			border-bottom-right-radius: 0;
			border-bottom-left-radius: 0;
		}

		div.phd-basket-usp > .phd-basket-panel:last-child {
			padding-top: .5em;
			border-top-right-radius: 0;
			border-top-left-radius: 0;
		}

		div.phd-basket-next {
			display: none;
		}

		div.phd-basket-next-mobile {
			display: block;
			position: absolute;
			width: 100%;
			padding: 1em 2em;
			bottom: 0;
			margin: 0 -2em;
			background: var(--phd-background-primary);
		}

		div.phd-basket-next-mobile .phd-button:first-child {
			margin-bottom: .5em;
		}
	}

	@media (max-width: 1024px) and (orientation: landscape) {
		div.phd-basket {
			font-size: .8em;
		}
	}
</style>

<div class="phd-basket">
	{#if loading}
		<div class="phd-basket-title">
			{#if $Product.erp}
				De <span>{$Product.api.name}</span> aanpassing wordt verwerkt...
			{:else}
				Jouw <span>plafondhoge deur</span> wordt verwerkt...
			{/if}
		</div>
	{:else if success}
		{#if $Product.erp}
			<div class="phd-basket-title">
				De <span>{$Product.api.name}</span> is aangepast!
			</div>
			<div class="phd-basket-next">
				<a href="{$Product.api.return_url}" class="phd-basket-panel">
					<span>Terug</span>
					<div>naar ERP</div>
				</a>
			</div>
			<div class="phd-basket-next-mobile">
				<a class="phd-button" href="{$Product.api.return_url}">Naar ERP</a>
			</div>
		{:else}
			<div class="phd-basket-title">
				Tadaaa!
				<svg version="1.1" viewBox="0 0 493.73 494.36" xmlns="http://www.w3.org/2000/svg">
					<style type="text/css">.pst0{fill:#FEB536;}.pst1{fill:#A06C34;}.pst2{fill:#FED368;}.pst3{fill:#FEB637;}.pst4{fill:#BEA4FD;}.pst5{fill:#FE6F83;}.pst6{fill:#5BCAFB;}.pst7{fill:#FE7084;}.pst8{fill:#FE7085;}.pst9{fill:#FEB739;}.pst10{fill:#FEB73A;}.pst11{fill:#5FCBFB;}.pst12{fill:#5DCBFB;}.pst13{fill:#F6F7A8;}</style>
					<path class="pst0" d="m364.03 349.6c-13.6 6.9-27.9 12.5-41.9 18.6-30.3 13.3-60.7 26.4-91 39.6-1.1 0.5-2.2 0.8-3.3 1.2-0.1-1-0.1-2-0.2-3-1-8.8-6.8-15.4-15.7-17.9-7.5-2.1-15.7 0.9-21.1 7.8-5 6.3-5.5 15.2-1.2 22.4 1.2 2 2.7 3.7 4.1 5.6-32.4 14.2-64.9 28.4-97.3 42.5-19.2 8.4-38.4 16.7-57.6 25.1-10.5 4.6-20.3 3.9-29.2-3.8 0.4-2.4 2-4.2 3.5-5.9 17.9-22.1 37.5-42.7 56.7-63.6 13.6-14.8 27.5-29.4 41.7-43.7 34.6-34.8 68.9-70 105.5-102.8 1.6-1.4 3.6-2.6 3.8-5.1 10.1 9.4 19.8 19.2 30.4 28.1 21 17.6 42.8 33.9 67.8 45.5 14.2 6.6 28.8 12.3 45 9.4z"/>
					<path class="pst1" d="m364.03 349.6c-16.3 2.9-30.8-2.8-45.1-9.4-25-11.6-46.8-27.9-67.8-45.5-10.6-8.9-20.3-18.7-30.4-28.1-7.4-8.1-14.9-16.1-22.2-24.3-11.2-12.6-20.9-26.3-30.7-40-6.2-10.5-12.4-21.1-17.5-32.3-5.2-11.6-8.9-23.5-8.7-36.4 2.7-17.3 15-20.2 28.5-18.6 8.5 1 16.4 3.8 24.3 6.9-2 4-4.1 7.9-6.1 11.9-3.4 6.8-1.5 13.6 4.5 16.7 6.1 3.2 12.5 0.8 16.3-5.9 2.3-4 4-8.4 7-12 17.4 10.4 33.8 22.3 49.4 35.2-0.8 1.8-2.7 2.4-4.1 3.5-13.2 10.2-15.7 26.7-6.2 40.3 6.6 9.4 16 14.4 26.9 16.6 7.3 1.5 12.8-2 14.1-8.4 1.2-6-2.7-10.8-9.9-12.5-5.1-1.2-9.9-3-13.3-7.3-2.6-3.3-3.6-7-0.2-10.3 3.4-3.4 7.5-5.4 12.5-4.4 18 17.7 35.4 36 50.7 56.2 3 4 5.8 8.1 8.7 12.1-1 1.7-2.9 2.2-4.5 2.9-12.6 5.4-24.1 12.7-34.8 21.3-6.4 5.2-7.6 12.1-3 17.9 4.5 5.8 11.6 6.3 18.1 1.2 5.4-4.2 10.9-8.3 16.8-11.6 7-3.8 13.7-8.3 22-9 8.1 14.5 15.5 29.4 17.7 46.2 1.2 8.9-0.1 17.2-7.2 23.7-1.6 1.8-3.6 2.6-5.8 3.4z"/>
					<path class="pst2" d="m167.93 202.4c9.7 13.7 19.5 27.4 30.7 40 7.3 8.2 14.8 16.2 22.2 24.3-0.2 2.5-2.2 3.7-3.8 5.1-36.6 32.8-70.9 67.9-105.5 102.8-14.2 14.3-28.1 28.9-41.7 43.7-19.2 20.9-38.8 41.5-56.7 63.6-1.4 1.8-3.1 3.5-3.5 5.9-9.1-8-12.1-19.1-7.5-30.1s8.9-22.2 14.4-32.8c0.4-0.4 0.8-0.9 1.2-1.3h-0.1c1.2-0.4 1.7-1.5 2.4-2.4 5.4-8.2 10.7-16.4 16.2-24.6 22.6-33.9 45.2-67.8 67.9-101.5 17.4-25.9 35-51.7 52.8-77.4 3.5-5.3 6.4-11 11-15.3zm-42.2 116.7c0 5.8 4.7 11 10 11.1 5.8 0.1 11.9-5.3 11.9-10.7 0.1-6-5-11.1-11.1-11-6.4 0.1-10.8 4.4-10.8 10.6z"/>
					<path class="pst3" d="m167.93 202.4c-4.6 4.4-7.5 10.1-11.1 15.2-17.8 25.7-35.3 51.5-52.8 77.4-22.7 33.8-45.3 67.7-67.9 101.5-5.4 8.2-10.8 16.4-16.2 24.6-0.6 1-1.1 2-2.4 2.4-0.6-1.6 0.3-2.9 0.9-4.3 40.8-94.8 81.6-189.6 122.4-284.5 0.2-0.4 0.6-0.8 0.9-1.2-0.2 12.9 3.5 24.8 8.7 36.4 5.1 11.3 11.3 21.9 17.5 32.5z"/>
					<path class="pst4" d="m285.53 185.5c-5-1-9.1 1-12.5 4.4s-2.4 7 0.2 10.3c3.3 4.3 8.1 6.1 13.3 7.3 7.2 1.6 11.1 6.5 9.9 12.5-1.3 6.4-6.8 9.9-14.1 8.4-11-2.2-20.3-7.3-26.9-16.6-9.6-13.6-7-30.1 6.2-40.3 1.4-1.1 3.3-1.7 4.1-3.5 8.5-2.9 17.2-5.6 26.3-4.2 4 0.6 7.9 0.8 11.8-0.2 4.5-1.2 8.7-3.1 9.7-8.2 1-4.9-2.7-7.7-6-10.1-2.9-2.2-6.5-3.1-10.2-3.7-11.9-2-22.2-6.9-29.2-17.2-11.1-16.4-4.6-37 13.8-44.6 6.9-2.8 14-3.7 21.4-3.3 6.1 0.4 12.3 1.1 18.1-2.1 6.1-3.4 7-8.3 2.4-13.4-3.9-4.3-9.1-5.9-14.4-7.3-7-1.8-10.1-8.7-7-15.2 2-4.1 5.8-6.1 9.8-5.7 13.7 1.5 28.9 9.4 34.3 24.6 5.6 15.8-3 32.1-20 38.1-6.9 2.5-14 3.6-21.5 2.4-6.2-1-12.7-1.1-17.9 3.8-4.1 3.8-4.1 7-0.6 11.3 4.1 5 9.8 6.6 15.8 7.6 10.8 1.8 19.6 7.1 26.5 15.6 12.6 15.6 5.7 38.8-13.9 46.2-8.1 3.1-16.4 4.3-24.9 2.4-1.6-0.3-3.2-0.5-4.5 0.7z"/>
					<path class="pst5" d="m359.53 276.4c-8.2 0.8-15 5.2-22 9-6 3.3-11.5 7.4-16.8 11.6-6.5 5.1-13.6 4.6-18.1-1.2-4.6-5.8-3.4-12.7 3-17.9 10.7-8.6 22.2-15.9 34.8-21.3 1.7-0.7 3.5-1.2 4.5-2.9 5.9-0.1 11.2-2.9 16.9-4.2 26.1-5.6 50.9-1.6 75.1 8.7 12.5 5.3 24 12.3 35.8 18.9 7 3.9 9.2 10.9 5.6 17.3-3.4 6-10.6 7.8-17.4 4-11.7-6.4-23-13.5-35.4-18.6-19.9-8.2-40.3-11.2-61.5-5.5-1.6 0.6-3.3 0.7-4.5 2.1z"/>
					<path class="pst6" d="m216.23 132.7c-3 3.6-4.8 7.9-7 12-3.8 6.7-10.2 9.1-16.3 5.9-6-3.1-7.8-9.9-4.5-16.7 2-4 4.1-8 6.1-11.9 8-13.2 14.2-27.2 15-42.9 0.9-16.4-6-30-16.7-42-5.4-5.9-11.5-11-17.8-16-5.2-4.1-6-11.1-2.3-16.1 3.7-4.9 10.6-6.7 15.6-3.1 19.9 14.5 36.3 31.9 42.5 56.6 4.9 19.5 1.5 38.3-6.4 56.4-2.6 6.1-5.4 12-8.2 17.8z"/>
					<path class="pst7" d="m390.13 171.7c-11.7 0-20.6-8.8-20.5-20.5 0-11.3 9-20.4 20.2-20.4 11.3 0 20.8 9.5 20.7 20.6s-9.3 20.2-20.4 20.3z"/>
					<path class="pst5" d="m193.83 424c-1.4-1.8-2.9-3.6-4.1-5.6-4.3-7.2-3.8-16.1 1.2-22.4 5.4-6.8 13.6-9.9 21.1-7.8 8.9 2.5 14.7 9.1 15.7 17.9 0.1 1 0.1 2 0.2 3-1.1 14-16.8 26.3-34.1 14.9z"/>
					<path class="pst8" d="m55.632 133.6c9.9 0 18 8 17.9 17.7-0.1 9.4-8.2 17.8-17.4 17.9-9.9 0.1-18.3-8.3-18.2-18.1 0.1-9.6 8.1-17.4 17.7-17.5z"/>
					<path class="pst9" d="m404.93 428.4c0 8.6-6.9 15.8-15.3 15.9-8.7 0.1-16-7.2-15.9-15.9 0.1-8.5 7.2-15.6 15.6-15.6 8.8 0 15.6 6.9 15.6 15.6z"/>
					<path class="pst10" d="m493.73 204.6c0.1 8.6-6.8 15.7-15.2 15.9-8.8 0.2-15.9-6.8-15.9-15.7 0-8.6 6.9-15.6 15.5-15.7 8.5-0.1 15.5 6.9 15.6 15.5z"/>
					<path class="pst11" d="m426.63 54.396c-0.1 6.2-5.1 11.2-11.1 11-6-0.1-10.9-5.4-10.7-11.5 0.2-5.9 5.1-10.5 11.1-10.4s10.8 5 10.7 10.9z"/>
					<path class="pst12" d="m38.232 3.5958c6.4 0.1 10.8 4.8 10.6 11.3-0.2 5.9-5.2 10.8-11 10.6-5.7-0.2-10.9-5.4-10.9-10.9 0.1-6.2 5.2-11.1 11.3-11z"/>
					<path class="pst3" d="m17.732 423.5c-0.4 0.4-0.8 0.9-1.2 1.3 0.1-0.6 0.2-1.3 1.2-1.3z"/>
					<path class="pst13" d="m125.73 319.1c0-6.2 4.4-10.5 10.8-10.6 6.1-0.1 11.2 5 11.1 11-0.1 5.4-6.2 10.8-11.9 10.7-5.3-0.1-10-5.3-10-11.1z"/>
				</svg>
				Jouw <span>plafondhoge<br/>deur</span> zit in het winkelmandje!
			</div>
			<div class="phd-basket-usp">
				<div class="phd-basket-panel">
					<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path fill="#B8A17F" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
					<div class="phd-basket-panel-label">Binnen 14 tot 16 weken in huis</div>
				</div>
				<div class="phd-basket-panel">
					<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path fill="#B8A17F" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
					<div class="phd-basket-panel-label">Betaal na inmeten</div>
				</div>
			</div>
			<div class="phd-basket-next">
				<a href="/collections/deurmodellen" class="phd-basket-panel">
					<div>Bijpassende deur?</div>
					<div class="phd-knob phd-knob-outline phd-knob-product">
						<svg viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"></path></svg>
					</div>
				</a>
				<a href="/cart" class="phd-basket-panel">
					<span>Winkelmandje</span>
					<div class="phd-knob phd-knob-outline phd-knob-basket">
						<svg viewBox="-3 -1 23 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
							<g stroke-width="2">
								<path fill="currentColor" d="M10.5882353,8 L10.5882353,4.08823529 C10.5882353,2.93493479 9.65330051,2 8.5,2 C7.34669949,2 6.41176471,2.93493479 6.41176471,4.08823529 L6.41176471,8 L2,8 L2,20 L15,20 L15,8 L10.5882353,8 Z M4.41176471,4.08823529 C4.41176471,1.83036529 6.24212999,0 8.5,0 C10.75787,0 12.5882353,1.83036529 12.5882353,4.08823529 L12.5882353,6 L17,6 L17,22 L0,22 L0,6 L4.41176471,6 L4.41176471,4.08823529 Z M5.41176471,6 L4.41176471,7 L4.41176471,6 L5.41176471,6 Z"></path>
								<polygon fill="currentColor" points="4 8 4 6 13 6 13 8"></polygon>
							</g>
						</svg>
					</div>
				</a>
			</div>
			<div class="phd-basket-next-mobile">
				<a class="phd-button phd-secondary" href="/collections/deurmodellen">Bijpassende deur?</a>
				<a class="phd-button" href="/cart">Verder</a>
			</div>
		{/if}
	{:else}
		<div class="phd-basket-title">
			Jouw <span>{$Product.api.name}</span> kan helaas niet verwerkt worden. Wil je even contact met ons opnemen?
		</div>
	{/if}
</div>
